// extracted by mini-css-extract-plugin
export default {"tableContainer":"styles_tableContainer__oD6qw"};